
import {Component, Prop, Vue} from "vue-property-decorator";
import ProduceNav from "@/components/product/ProductNav.vue";
import ProduceNavVue from "@/components/product/ProductNav.vue";
import {RouterHelper} from "../../../router/routerHelper";

@Component({
  components: {
    "product-nav": ProduceNavVue,
  },
})
export default class LiteBeeBot extends Vue {
  prodName: string = "LiteBee Bot";
  prodCode: string = "liteBeeBot";
  tabList: Array<any> = RouterHelper.getProdRouterConfig(this.prodCode);

  mounted() {
    new (<any>window).WOW().init();
  }
}
